import styled from 'styled-components'
import { space, fontSize, width, color, fontWeight } from 'styled-system'
import { lineHeight, whiteSpace } from './css'

const P = styled.p`
  ${space} ${whiteSpace} ${lineHeight} ${width} ${color} ${fontWeight} ${fontSize};
`

export default P
